import type { ReactNode } from "react"
import React from "react"

import type { StackProps } from "@chakra-ui/react"
import { Stack, Text } from "@chakra-ui/react"

type HeadingProps = StackProps & {
  heading: string | ReactNode
}

export const Heading = ({ heading, ...rest }: HeadingProps) => {
  return (
    <Stack w="full" direction="row" align="center" {...rest}>
      {typeof heading === "string" ? (
        <Text
          fontSize={{ base: 16, sm: 18 }}
          lineHeight={1.2}
          fontWeight={600}
          style={{ userSelect: "none" }}
        >
          {heading}
        </Text>
      ) : (
        heading
      )}
    </Stack>
  )
}
